import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

/* Options */
import widthNav, { maxWidth } from './windowWidthNavConfig'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    drawer: {
      zIndex: theme.zIndex.modal + 1,
      '& .MuiBackdrop-root': {
        zIndex: theme.zIndex.modal,
      },
      '& .MuiPaper-root': {
        width: '250px',
        maxWidth: '100%',
        zIndex: theme.zIndex.modal + 1,
        maxHeight: '100dvh',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        WebkitOverflowScrolling: 'touch',
      },
    },

    list:{
      '& a, & a:visited': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
    menuBranchListItem: {
      padding: 0,
      display: 'flex',
      alignItems: 'stretch',
    },
    menuBranchButton: {
      border: 0,
      background: 'transparent',
      color: 'inherit',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      flex: '1 1 auto',
      minWidth: 0,
      padding: '8px 16px',
      textAlign: 'left',
      font: 'inherit',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    menuTargetButton: {
      alignSelf: 'center',
      flex: '0 0 auto',
      marginRight: theme.spacing(0.5),
    },
    visuallyHidden: {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      whiteSpace: 'nowrap',
      border: 0,
    },
    divider:{},

    mainMenuList: {},
    menuHome: {[theme.breakpoints.up(widthNav.home)]: {
      display: 'none',
    }},
    menuKonto: {},
    menuFavs: {},

    
  })
)

export default useStyles
